import './lib/extensions'
import 'animate.css'
import 'devextreme/dist/css/dx.common.css'

import { createApp } from 'vue'

import App from './App.vue'
import i18n from './plugins/i18n'
import pinia from './plugins/pinia'
import router from './router'
import Quasar from 'quasar/src/vue-plugin.js';
import quasarUserOptions from './plugins/quasar'
import httpApi from './plugins/httpapi'

createApp(App)
.use(Quasar, quasarUserOptions)
.use(i18n)
.use(httpApi)
.use(pinia)
.use(router)
.mount('#app')

import '@/plugins/devextreme'
import '@/styles/style.scss'
